namespace TR {

    export enum KeyCode {
        TAB = 9,
        RETURN = 13,
        ESC = 27,
        SPACE = 32,
        PAGEUP = 33,
        PAGEDOWN = 34,
        END = 35,
        HOME = 36,
        LEFT = 37,
        UP = 38,
        RIGHT = 39,
        DOWN = 40
    }

    export interface ComponentUtil {
        getRandomID(prefix: string): string;
    }
}
